const AbacusDisplay = ({ value, showOperation = false, operation = "" }) => {
  const renderAbacusBeads = (num) => {
    const beads = []
    const topBeads = Math.floor(num / 5)
    const bottomBeads = num % 5

    // Верхняя часть абакуса
    beads.push(
      <div key="top" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "8px" }}>
        <div style={{ width: "4px", height: "32px", backgroundColor: "#d97706" }}></div>
        {topBeads > 0 ? (
          <div
            style={{
              width: "32px",
              height: "24px",
              backgroundColor: "#22c55e",
              borderRadius: "50%",
              border: "2px solid #16a34a",
              marginBottom: "4px",
            }}
          ></div>
        ) : (
          <div
            style={{
              width: "32px",
              height: "24px",
              border: "2px solid #d1d5db",
              borderRadius: "50%",
              marginBottom: "4px",
            }}
          ></div>
        )}
      </div>,
    )

    // Разделительная линия
    beads.push(
      <div
        key="separator"
        style={{ width: "48px", height: "4px", backgroundColor: "#d97706", marginBottom: "8px" }}
      ></div>,
    )

    // Нижние косточки
    beads.push(
      <div key="bottom" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {Array.from({ length: 4 }, (_, i) => (
          <div
            key={i}
            style={{
              width: "24px",
              height: "20px",
              borderRadius: "50%",
              border: "2px solid",
              marginBottom: "4px",
              backgroundColor: i < bottomBeads ? "#8b5cf6" : "transparent",
              borderColor: i < bottomBeads ? "#7c3aed" : "#d1d5db",
            }}
          ></div>
        ))}
        <div style={{ width: "4px", height: "32px", backgroundColor: "#d97706" }}></div>
      </div>,
    )

    return beads
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "16px",
        backgroundColor: "#fef3c7",
        borderRadius: "8px",
        border: "2px solid #f59e0b",
      }}
    >
      {showOperation && (
        <div style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "8px" }}>{operation}</div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#fed7aa",
          padding: "16px",
          borderRadius: "8px",
          border: "2px solid #f59e0b",
        }}
      >
        {renderAbacusBeads(value)}
      </div>
      <div style={{ fontSize: "1.5rem", fontWeight: "bold", marginTop: "8px" }}>{value}</div>
    </div>
  )
}

export default AbacusDisplay
